import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import { LottiePlayer } from '@repo/design-system-kit';
import lottiePath from '@repo/visual-assets/animations/lottie_cp_general_generic_error.lottie';
import styles from './not-found.module.css';

interface NotFoundState {
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
}

export function NotFound(): ReactNode {
  const location = useLocation();
  const state = location.state as NotFoundState | undefined;

  const title = state?.title ?? <FormattedMessage id="error-states.not-available.title" />;
  const subtitle = state?.subtitle ?? <FormattedMessage id="error-states.not-available.subtitle" />;

  return (
    <main className={styles.container} data-test-error-page>
      <LottiePlayer className={styles.lottie} data-test-error-illustration path={lottiePath} />
      <div className={styles.textContainer}>
        <h1 className="title-2 mb-16" data-test-error-title>
          {title}
        </h1>
        <p className="body-1" data-test-error-subtitle>
          {subtitle}
        </p>
      </div>
    </main>
  );
}
